import api from './api';

/** Tranche B4 follow-up (#489): KI-Konfiguration je Unternehmen. */
export interface CompanyAiConfig {
    companyId: number;
    persisted: boolean;
    contentGeneratorEnabled: boolean;
    qualityCheckEnabled: boolean;
    knowledgeBaseEnabled: boolean;
    helpBotEnabled: boolean;
    recommendationsEnabled: boolean;
    learningPathsEnabled: boolean;
    requireSignOffForAiCourses: boolean;
    tutorPrompt: string | null;
    dailyCourseGenerationLimit: number;
    dailyContentJobLimit: number;
    dailyVariantLimit: number;
    canEditLimits: boolean;
    defaults: { dailyCourseGenerationLimit: number; dailyContentJobLimit: number; dailyVariantLimit: number };
}

export type CompanyAiConfigInput = Partial<Pick<CompanyAiConfig, 'contentGeneratorEnabled' | 'qualityCheckEnabled' | 'knowledgeBaseEnabled' | 'helpBotEnabled' | 'recommendationsEnabled' | 'learningPathsEnabled' | 'requireSignOffForAiCourses' | 'tutorPrompt' | 'dailyCourseGenerationLimit' | 'dailyContentJobLimit' | 'dailyVariantLimit'>>;

const query = (companyId?: number | null): string => (companyId ? `?companyId=${companyId}` : '');

export const companyAiConfigService = {
    async get(companyId?: number | null): Promise<CompanyAiConfig> {
        const { data } = await api.get(`/ai/company-config${query(companyId)}`);
        return data;
    },
    async update(input: CompanyAiConfigInput, companyId?: number | null): Promise<CompanyAiConfig> {
        const { data } = await api.put(`/ai/company-config${query(companyId)}`, input);
        return data;
    },
};

export default companyAiConfigService;
